import { connect } from "react-redux";
import { RootState } from "store/store";
import TenantStatus from "./TenantStatus";
import { setTenantStatusOpened } from "store/environments/tenants/tenant-status/tenant-status-actions";
import {
    getPingInfo,
    getTenantsPingInfoSelector,
} from "store/environments/tenants/tenant-ping/tenant-ping-selectors";
import { getActiveEnvironmentMoniker } from "store/environments/environment-selectors";
import { pingTenantInD365 } from "store/environments/tenants/tenant-ping/tenant-ping-thunk";

const mapStateToProps = (state: RootState) => {
    const envMoniker = getActiveEnvironmentMoniker(state);

    return {
        activeEnvMoniker: envMoniker,
        tenantsPingInfo: getTenantsPingInfoSelector(state, envMoniker),
        tenantVersionInfo: state.tenantStatusReducer.tenantVersionInfo,
        isTenantStatusOpened: state.tenantStatusReducer.isTenantStatusOpened,
    };
};
const TenantStatusContainer = connect(mapStateToProps, {
    setTenantStatusOpened,
    getPingInfo,
    pingTenantInD365,
})(TenantStatus);

export default TenantStatusContainer;
